import { render, staticRenderFns } from "./cargo-correction.vue?vue&type=template&id=09276124&scoped=true"
import script from "./cargo-correction.vue?vue&type=script&lang=js"
export * from "./cargo-correction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09276124",
  null
  
)

export default component.exports